import React from "react"
import { Route, IndexRoute } from "react-router"

import requireAuth from "./components/auth/require_auth"
import App from "./App"
import Signin from "./components/auth/signin"
import Signout from "./components/auth/signout"
// import Signup from './components/auth/signup';
import Dashboard from "./components/dashboard"

import Venue from "./components/venues/new"
import Venues from "./components/venues/list"
import VenueShow from "./components/venues/show"
import VenueEdit from "./components/venues/edit"

import Event from "./components/events/new"
import Events from "./components/events/list"
import EventShow from "./components/events/show"
import EventEdit from "./components/events/edit"
import EventDelete from "./components/events/delete"

import Notification from "./components/notifications/new"
import Notifications from "./components/notifications/list"
import NotificationShow from "./components/notifications/show"

import NotFound from "./components/NotFound"

module.exports = (
  <Route path="/" component={App}>
    <IndexRoute component={Signin} />
    <Route path="signin" component={Signin} />
    <Route path="signout" component={requireAuth(Signout)} />
    {/* <Route path="signup" component={Signup} /> */}

    <Route path="/events/new" component={requireAuth(Event)} />
    <Route path="/events/:id" component={requireAuth(EventShow)} />
    <Route path="/events/:id/edit" component={requireAuth(EventEdit)} />
    <Route path="/events/:id/delete" component={requireAuth(EventDelete)} />
    <Route path="/events" component={requireAuth(Events)} />

    <Route path="/venues/new" component={requireAuth(Venue)} />
    <Route path="/venues/:id" component={requireAuth(VenueShow)} />
    <Route path="/venues/:id/edit" component={requireAuth(VenueEdit)} />
    <Route path="/venues" component={requireAuth(Venues)} />

    <Route path="/notifications/new" component={requireAuth(Notification)} />
    <Route path="/notifications" component={requireAuth(Notifications)} />
    <Route
      path="/notifications/:id"
      component={requireAuth(NotificationShow)}
    />

    <Route path="dashboard" component={requireAuth(Dashboard)} />
    <Route path="*" component={NotFound} />
  </Route>
)



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/